import { render, staticRenderFns } from "./BillboardListItem.vue?vue&type=template&id=07218ac9"
import script from "./BillboardListItem.vue?vue&type=script&lang=js"
export * from "./BillboardListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports